"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemCodeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const RedeemField_1 = __importDefault(require("../RedeemField"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function RedeemCodeInput(_a) {
    var { onChange: onCodeChange, code } = _a, props = __rest(_a, ["onChange", "code"]);
    const [outlineAvailability, setOutlineAvailability] = (0, react_1.useState)(true);
    const { onPaste, onKeyDown: onInputKeyDown, onChange, ref: inputsRef, } = (0, hooks_1.useRedeemInputs)(code, onCodeChange);
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { t } = (0, i18n_1.useTranslation)();
    const onKeyDown = (i) => {
        const inputKeyDown = onInputKeyDown(i);
        return (e) => {
            /**
             * Hide outline on keyboard input
             */
            if (e.key === 'Tab') {
                setOutlineAvailability(true);
            }
            else {
                setOutlineAvailability(false);
            }
            inputKeyDown(e);
        };
    };
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({ onPaste: onPaste }, props, { role: "group", "aria-label": t(i18n_1.Strings.profile.redeem.inputGroup), "data-e2e": 'RedeemCodeInput_Container', children: code.map((symbol, i) => ((0, jsx_runtime_1.jsx)(RedeemField_1.default, { ref: inputsRef(i), value: symbol, onKeyDown: onKeyDown(i), onChange: onChange(i), disabled: isOffline, outline: outlineAvailability, ariaLabel: `Digit ${i + 1}`, inputIndex: i, "data-e2e": 'RedeemCodeInput_RedeemField' }, i))) })));
}
exports.RedeemCodeInput = RedeemCodeInput;
const Container = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  width: 100%;

  margin: 0 0 12px 0;

  ${ui_1.device.mobileL((0, styled_components_1.css) `
    flex-wrap: nowrap;
    justify-content: space-around;

    margin: 0 auto 20px auto;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    flex-wrap: nowrap;

    margin: 0 0 20px 0;
  `)}
`;
